import { render, staticRenderFns } from "./AlarmQueue.vue?vue&type=template&id=016a14d6&scoped=true"
import script from "./AlarmQueue.vue?vue&type=script&lang=ts"
export * from "./AlarmQueue.vue?vue&type=script&lang=ts"
import style0 from "./AlarmQueue.vue?vue&type=style&index=0&id=016a14d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016a14d6",
  null
  
)

export default component.exports